import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  trackShareClick, shareByEmail, VIEWER_ROLE
} from 'LiveBoard/modules/cta'
import countBy from 'lodash/countBy'

const SHARE_URLS = {
  facebook: 'https://www.facebook.com/sharer/sharer.php?display=popup&u=',
  twitter: 'https://twitter.com/intent/tweet?tw_p=tweetbutton&url=',
  linkedin: 'https://www.linkedin.com/cws/share?url='
}

const ShareBoardContainer = ({
  boardId,
  config,
  themeColorHex,
  textColor,
  trackShareClick,
  shareByEmail,
  component: ShareBoard
}) => {
  const handleEmailShare = (values, options) => {
    shareByEmail(values.email, options)
  }

  return (
    <ShareBoard
      config={config}
      themeColorHex={themeColorHex}
      textColor={textColor}
      trackShareClick={trackShareClick}
      onEmailShare={handleEmailShare}
      numberOfShareOptions={countBy(config).true}
      shareUrls={SHARE_URLS} />
  )
}

ShareBoardContainer.propTypes = {
  component: PropTypes.object.isRequired,
  boardId: PropTypes.number.isRequired,
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  trackShareClick: PropTypes.func.isRequired,
  shareByEmail: PropTypes.func.isRequired
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ trackShareClick, shareByEmail }, dispatch)
}

export default connect(null, mapDispatchToProps)(ShareBoardContainer)
